import React, {Component}               from "react";
import {ImageBackground, Text, View}    from "react-native";
import {connect}                        from "react-redux";
import Modal                            from "./Modal";
import NBButton                         from "../NBButton";
import * as Actions                     from "../../constants/Actions";
import styles                           from "../../styles/Styles";

class ModalRoundEnd extends Component {
    render() {
        var message = null;
        var title   = null;
        if (this.props.ejected) {
            message = "The answer was " + this.props.answer;
            title   = "That was a hard one";
        }
        else {
            message = this.props.swipeControls ? "You have" : this.props.players[this.props.currentPlayer].name + " has";
            message += " chosen wisely. The answer is " + this.props.answer;
            title   = "Correct!";
        }

        return (
            <View>
                <Modal animationType={"fade"} onRequestClose={null} supportedOrientations={["landscape"]} transparent={true}
                    visible={this.props.roundEnd}>
                    {/* Modal Background is a hack to dim the screen behind the modal */}
                    <View style={styles.modalBackground}>
                        <View style={styles.modalDialog}>
                            <ImageBackground source={require("../../../assets/clapboard_temp.png")} style={styles.backgroundModal} imageStyle={styles.backgroundImageStretch}>
                                <View style={styles.modalDialogInner}>
                                    {/* Header Row */}
                                    <View style={styles.modalDetailRow}>
                                        <Text style={styles.modalDetailText}>{title}</Text>
                                    </View>
                                    <View style={styles.lineHorizontalModal} />

                                    <View style={styles.modalDetailRow}>
                                        <Text style={styles.modalDetailText}>{message}</Text>
                                    </View>

                                    <View style={styles.modalButtonPanel}>
                                        <NBButton onPress={this.props.continue} text={"Continue"} />
                                    </View>
                                </View>
                            </ImageBackground>
                        </View>
                    </View>
                </Modal>
            </View>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        answer:         state.answer,
        currentPlayer:  state.currentPlayer,
        ejected:        state.ejected,
        players:        state.players,
        roundEnd:       state.roundEnd,
        swipeControls:  state.swipeControls
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        continue: () => { dispatch({type: Actions.CONTINUE}) },
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalRoundEnd);